import React from 'react';

import { Link, LINK_SEVERITY } from '@tmapy/style-guide';

import type { PersonData } from '../types';

interface DetailPersonProps {
  person: PersonData;
}

export const DetailPerson: React.FC<DetailPersonProps> = ({ person }) => {
  return (
    <>
      <p>{person.name}</p>
      {person.company && <p className='sg-u-type-sml sg-a-mt-1/2'>{person.company}</p>}
      {person.email && (
        <p className='sg-u-type-sml sg-a-mt-1/2'>
          <Link href={`mailto:${person.email}`} severity={LINK_SEVERITY.COLORFUL}>
            {person.email}
          </Link>
        </p>
      )}
      {person.phone && (
        <p className='sg-u-type-sml sg-a-mt-1/2'>
          <Link href={`tel:${person.phone}`} severity={LINK_SEVERITY.COLORFUL}>
            {person.phone}
          </Link>
        </p>
      )}
    </>
  );
};
